(function(){
  class LvUpsell extends HTMLElement {
    connectedCallback() {
      const root = this;
      const cards = root.querySelectorAll('.lv-card');
      const savingsRow = root.querySelector('[data-lv-savings-row]');
      const savingsAmountEl = root.querySelector('[data-lv-savings-amount]');
      const packCountEl = root.querySelector('[data-lv-pack-count]');

      const lvSetVariant = (variantLabel) => {
        const variantMap = {
          '1 balení': '58125807223165',
          '2 balení': '58125807255933',
          '3 balení': '58125807288701'
        };
        const variantId = variantMap[variantLabel];
        if (!variantId) return;
        const inputs = document.querySelectorAll('input[name="id"]');
        inputs.forEach(function(input) {
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        const variantPicker = document.querySelector('variant-picker, variant-selects');
        if (variantPicker) {
          const event = new CustomEvent('variant:change', {
            bubbles: true,
            detail: { variant: { id: parseInt(variantId) } }
          });
          variantPicker.dispatchEvent(event);
        }
      };

      const lvUpdateSavings = (card) => {
        const savings = parseInt(card.getAttribute('data-lv-savings'), 10) || 0;
        const variantLabel = card.getAttribute('data-lv-variant') || '';
        const packMatch = variantLabel.match(/\d+/);
        const packCount = packMatch ? packMatch[0] : '1';
        if (savings > 0) {
          savingsRow.classList.remove('lv-hidden');
          savingsAmountEl.textContent = savings.toLocaleString('cs-CZ').replace(/,/g, ' ');
          packCountEl.textContent = packCount;
        } else {
          savingsRow.classList.add('lv-hidden');
        }
      };

      const lvSelectCard = (card) => {
        cards.forEach(c => c.classList.remove('lv-active'));
        card.classList.add('lv-active');
        const variantLabel = card.getAttribute('data-lv-variant');
        if (variantLabel) lvSetVariant(variantLabel);
        lvUpdateSavings(card);
      };

      cards.forEach(card => {
        card.addEventListener('click', () => lvSelectCard(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            lvSelectCard(card);
          }
        });
        card.setAttribute('tabindex', '0');
        card.setAttribute('role', 'button');
      });

      const initialActive = root.querySelector('.lv-card.lv-active') || cards[cards.length - 1];
      if (initialActive) {
        requestAnimationFrame(() => {
          const variantLabel = initialActive.getAttribute('data-lv-variant');
          if (variantLabel) lvSetVariant(variantLabel);
          lvUpdateSavings(initialActive);
        });
      }
    }
  }
  if (!customElements.get('lv-upsell')) {
    customElements.define('lv-upsell', LvUpsell);
  }
})();